import {HTML_ELEMENT_DIV} from '../appConstants';

export const ISO_DATE: string = 'isoDate';

/**
 * Appends Current Date ISO String value to input object.
 * e.g. "2019-11-30T17:57:16.124Z"
 * @param input {any} input object to which ISO_DATE will be added as key.
 */
export const appendISODate = (input: any): void => {
    input[ISO_DATE] =  new Date().toISOString();
};

export const convertHtmlToPlainText = (htmlFormatedString: string) => {
    let plainTextString = document.createElement(HTML_ELEMENT_DIV);
    plainTextString.innerHTML = htmlFormatedString;
    return plainTextString.textContent || plainTextString.innerText || "";
}; 